import { DESIGN_SYSTEM_THEME } from '../../../constants/config'
import { Colors } from '../../types/colors'
import { iconSizes as sharedIconSizes } from '../shared/icon-sizes'

import prosperiaColors from './prosperia/colors'
import { fontFamily as prosperiaFontFamily } from './prosperia/typography'
import { fontFamilyBold as prosperiaFontFamilyBold } from './prosperia/typography'
import { font as prosperiaFont } from './prosperia/typography'

type Theme = 'prosperia'

type ThemeType = Record<Theme, Colors>

const partnerColors: ThemeType = {
  prosperia: prosperiaColors,
}

const partnerFont: Record<string, string> = {
  prosperia: prosperiaFont,
}

const partnerFontFamily: Record<string, string> = {
  prosperia: prosperiaFontFamily,
}

const partnerFontFamilyBold: Record<string, string> = {
  prosperia: prosperiaFontFamilyBold,
}

export const colors = partnerColors[DESIGN_SYSTEM_THEME] || partnerColors.prosperia

export const fontFamily = partnerFontFamily[DESIGN_SYSTEM_THEME] || partnerFontFamily.prosperia
export const fontFamilyBold = partnerFontFamilyBold[DESIGN_SYSTEM_THEME] || partnerFontFamilyBold.prosperia

export const font = partnerFont[DESIGN_SYSTEM_THEME] || partnerFont.prosperia

export const iconSizes = sharedIconSizes
